import type { ITariffZone } from '../../../models/tariff-zone.model';

export class TariffZoneApiModel {
  public static mapToBusinessModel(apiModel: TariffZoneApiModel | undefined): ITariffZone | undefined {
    if (!apiModel) {
      return undefined;
    }
    return {
      number: apiModel.number,
      name: apiModel.name,
      shortName: apiModel.shortName,
    };
  }

  public number!: number;
  public name!: string;
  public shortName!: string;
}
